import { render, staticRenderFns } from "./SmartPoster.vue?vue&type=template&id=13bb6a7a&scoped=true"
import script from "./SmartPoster.vue?vue&type=script&lang=js"
export * from "./SmartPoster.vue?vue&type=script&lang=js"
import style0 from "./SmartPoster.vue?vue&type=style&index=0&id=13bb6a7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb6a7a",
  null
  
)

export default component.exports